module.exports = __webpack_public_path__ + "static/media/1.solving-equations.ccf00a86.png";